import { render, staticRenderFns } from "./GapInputs.vue?vue&type=template&id=bdd81118&scoped=true"
import script from "./GapInputs.vue?vue&type=script&lang=ts"
export * from "./GapInputs.vue?vue&type=script&lang=ts"
import style0 from "./GapInputs.vue?vue&type=style&index=0&id=bdd81118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd81118",
  null
  
)

/* custom blocks */
import block0 from "./GapInputs.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports